import styled from "styled-components";

export const StyledWrapper = styled.div`
  box-sizing: border-box;
  height: 32px;
  width: 32px;
  :hover {
    cursor: pointer;
  }
`;
